import { useState } from 'react';
import { faqs } from '@/mocks/site';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 border-y border-background-200 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="font-label text-xs tracking-[0.25em] text-primary-600 mb-3">
              FAQ / 常见问题
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              看爆料短剧时，大家最常问的几个问题
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              这些问题大多和片尾声明的措辞有关。理解措辞的差别，基本就能自己判断一部剧的可信边界。
            </p>
            <a
              href="mailto:contact@juzhen-dangan.example.com"
              className="mt-6 inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors"
            >
              <i className="ri-question-answer-line"></i>
              还有问题？写信给我们
            </a>
          </div>

          <div className="lg:col-span-8">
            <ul className="border-t border-background-300/70">
              {faqs.map((item, idx) => {
                const isOpen = openIndex === idx;
                return (
                  <li key={item.q} className="border-b border-background-300/70">
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : idx)}
                        aria-expanded={isOpen}
                        className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
                      >
                        <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                          {item.q}
                        </span>
                        <span
                          className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md border transition-colors ${
                            isOpen
                              ? 'bg-primary-500 border-primary-500 text-background-50'
                              : 'border-background-300 text-foreground-500'
                          }`}
                        >
                          <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="pb-5 pr-8">
                        <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
    </section>
  );
}